<script setup lang="ts">
import {watchEffect} from "vue";
import {Icon} from "./";
import {Colors} from "@/Enums";

const model = defineModel();

watchEffect(() => {
    if (model.value === null) {
        let aSlugs = Object.keys(Colors);
        model.value = aSlugs[Math.floor(Math.random() * aSlugs.length)];
    }
});
</script>
<template>
    <div class="grid w-full grid-cols-12 gap-0.5 md:gap-1 lg:gap-1">
        <template v-for="(color, slug) in Colors">
            <div class="flex justify-center">
                <button
                    type="button"
                    :title="color.name"
                    class="flex aspect-square w-full cursor-pointer items-center justify-center rounded-full text-[0.5rem] sm:text-sm md:text-2xl"
                    :class="`bg-${color.class}`"
                    @click="model = slug"
                >
                    <Icon
                        v-if="slug === model"
                        icon="fa:check"
                        :class="color.class === 'white' ? 'text-black' : 'text-white'"
                    />
                </button>
            </div>
        </template>
    </div>
</template>
<style scoped></style>
